export const testimonials = [
  {
    id: 1,
    name: '小雨',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20warm%20smile%2C%20soft%20natural%20lighting%2C%20clean%20studio%20background%20with%20warm%20beige%20tones%2C%20professional%20headshot%20style%2C%20gentle%20expression%2C%20casual%20elegant%20look%2C%20Korean%20beauty%20aesthetic&width=400&height=400&seq=avatar-testimonial-01&orientation=portrait',
    role: '忠实读者 · 3年漫龄',
    quote: '从高中开始就在酷漫屋看漫画了，这里的韩漫资源真的太全了！画质清晰，更新速度也很快，每次打开都有新惊喜。最喜欢的是下拉式阅读体验，非常流畅舒服。',
    rating: 5,
  },
  {
    id: 2,
    name: '阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20man%20portrait%20with%20confident%20expression%2C%20soft%20studio%20lighting%2C%20clean%20warm%20background%2C%20professional%20headshot%20style%2C%20modern%20casual%20look%2C%20friendly%20vibe&width=400&height=400&seq=avatar-testimonial-02&orientation=portrait',
    role: '热血漫爱好者',
    quote: '作为一个热血漫的铁粉，酷漫屋的分类做得特别好，能快速找到我喜欢的类型。而且每周都有更新提醒，再也不用担心错过最新章节了。强烈推荐给所有漫迷！',
    rating: 5,
  },
  {
    id: 3,
    name: '晓晓',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20woman%20portrait%20with%20bright%20smile%2C%20soft%20natural%20lighting%2C%20clean%20pastel%20background%2C%20professional%20headshot%20style%2C%20sweet%20expression%2C%20Korean%20beauty%20aesthetic%2C%20fresh%20and%20youthful&width=400&height=400&seq=avatar-testimonial-03&orientation=portrait',
    role: '少女漫深度用户',
    quote: '酷漫屋的少女漫画专区是我的快乐源泉！画风精美，故事动人，而且全部免费。下拉式浏览让追漫变得超级方便，不知不觉就能看一个下午。真心感谢酷漫屋团队！',
    rating: 5,
  },
];

export const reputationData = [
  { label: '累计用户', value: '5800万+', icon: 'ri-user-line' },
  { label: '漫画作品', value: '12万+', icon: 'ri-book-open-line' },
  { label: '日均更新', value: '300+', icon: 'ri-refresh-line' },
  { label: '用户好评', value: '98.5%', icon: 'ri-heart-line' },
];